import { useState, useEffect } from 'react';
import { IonPage, IonContent } from '@ionic/react';
import { useLocation } from 'react-router-dom';
import { CallList } from '../components/calls/CallList';
import { useBreadcrumbStore } from '../store/useBreadcrumbStore';
import { getPropertyById } from '../services/propertyService';
import { getAgentById } from '../services/agentService';
import { getClientById } from '../services/clientService';

export default function CallsPage() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const clientId = params.get('clientId') || undefined;
  const propertyId = params.get('propertyId') || undefined;
  const agentId = params.get('agentId') || undefined;

  const [contextName, setContextName] = useState('');
  const setBreadcrumb = useBreadcrumbStore((s) => s.set);

  useEffect(() => {
    if (location.pathname !== '/calls') return;

    // Property context with agent (from property > agents > calls)
    if (agentId && propertyId && clientId) {
      Promise.all([getAgentById(agentId), getPropertyById(propertyId), getClientById(clientId)]).then(([agent, property, client]) => {
        setContextName(agent.name || agentId);
        setBreadcrumb([
          { label: 'Clients', path: '/clients' },
          { label: client.name || clientId, path: `/client-detail?clientId=${clientId}` },
          { label: 'Properties', path: `/properties?clientId=${clientId}` },
          { label: property.name || propertyId, path: `/agents?clientId=${clientId}&propertyId=${propertyId}` },
          { label: 'Agents', path: `/agents?clientId=${clientId}&propertyId=${propertyId}` },
          { label: 'Calls' },
        ]);
      });
    } else if (propertyId && clientId) {
      Promise.all([getPropertyById(propertyId), getClientById(clientId)]).then(([property, client]) => {
        setContextName(property.name || propertyId);
        setBreadcrumb([
          { label: 'Clients', path: '/clients' },
          { label: client.name || clientId, path: `/client-detail?clientId=${clientId}` },
          { label: 'Properties', path: `/properties?clientId=${clientId}` },
          { label: property.name || propertyId },
          { label: 'Calls' },
        ]);
      });
    } else if (propertyId) {
      getPropertyById(propertyId).then((property) => {
        setContextName(property.name || propertyId);
        if (property.clientId) {
          getClientById(property.clientId).then((client) => {
            setBreadcrumb([
              { label: 'Clients', path: '/clients' },
              { label: client.name || property.clientId!, path: `/client-detail?clientId=${property.clientId}` },
              { label: 'Properties', path: `/properties?clientId=${property.clientId}` },
              { label: property.name || propertyId },
              { label: 'Calls' },
            ]);
          });
        } else {
          setBreadcrumb([
            { label: 'Properties', path: '/properties' },
            { label: property.name || propertyId },
            { label: 'Calls' },
          ]);
        }
      });
    } else if (agentId && clientId) {
      Promise.all([getAgentById(agentId), getClientById(clientId)]).then(([agent, client]) => {
        setContextName(agent.name || agentId);
        setBreadcrumb([
          { label: 'Clients', path: '/clients' },
          { label: client.name || clientId, path: `/client-detail?clientId=${clientId}` },
          { label: 'Agents', path: `/agents?clientId=${clientId}` },
          { label: 'Calls' },
        ]);
      });
    } else if (agentId) {
      getAgentById(agentId).then((agent) => {
        setContextName(agent.name || agentId);
        setBreadcrumb([
          { label: 'Agents', path: '/agents' },
          { label: agent.name || agentId },
          { label: 'Calls' },
        ]);
      });
    } else if (clientId) {
      getClientById(clientId).then((client) => {
        setContextName(client.name || clientId);
        setBreadcrumb([
          { label: 'Clients', path: '/clients' },
          { label: client.name || clientId, path: `/client-detail?clientId=${clientId}` },
          { label: 'Calls' },
        ]);
      });
    } else {
      setContextName('');
      setBreadcrumb([{ label: 'Calls' }]);
    }
  }, [location.pathname, clientId, propertyId, agentId, setBreadcrumb]);

  const title = contextName ? `Calls - ${contextName}` : 'Calls';
  const filter = propertyId
    ? { propertyId, ...(clientId && { clientId }) }
    : agentId
      ? { agentId, ...(clientId && { clientId }) }
      : clientId
        ? { clientId }
        : undefined;

  return (
    <IonPage>
      <IonContent>
        <div className="p-4 sm:p-6 lg:p-8">
          <CallList title={title} filter={filter} />
        </div>
      </IonContent>
    </IonPage>
  );
}
